<template>
    <div class="checkbox-filter">
        <md-checkbox v-model="checked" @change="emitChange">{{ label }}</md-checkbox>
    </div>
</template>

<script>
import { FILTER_IDS } from '@/utils/constants';

export default {
    name: 'CheckboxFilter',
    props: {
        id: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        },
        currentFilterValue: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checked: this.value,
            filterIds: FILTER_IDS,
            tempChecked: this.value
        };
    },
    watch: {
        value(newValue) {
            this.checked = Boolean(newValue);
        }
    },
    methods: {
        emitChange() {
            this.$emit('change', {
                id: this.id,
                value: Boolean(this.checked),
                component: 'CheckboxFilter'
            });
        },
        reset() {
            this.checked = this.currentFilterValue;
            this.emitChange();
        }
    }
};
</script>

<style scoped>
.checkbox-filter {
    display: inline-flex;
}
</style>
